import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import ConfigurationAutomationPersonnelAlgorithmsDefinitionModalBasicForm
    from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/components/modal-basic-form/configuration-automation-personnel-algorithms-definition-modal-basic-form.vue'
import ConfigurationAutomationPersonnelAlgorithmsDefinitionModalStepsForm
    from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/components/modal-steps-form/configuration-automation-personnel-algorithms-definition-modal-steps-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationAutomationPersonnelAlgorithmsDefinitionModalState,
    initialConfigurationAutomationPersonnelAlgorithmsDefinitionModalState
} from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/components/modal/configuration-automation-personnel-algorithms-definition-modal.model'
import {
    ConfigurationAutomaticAssignmentAlgorithmCreateRequest,
    ConfigurationAutomaticAssignmentAlgorithmPatchInBatchRequest, ConfigurationAutomaticAssignmentAlgorithmResponse
} from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm/configuration-automatic-assignment-algorithm.dto'

@Component({
    components: {
        ConfigurationAutomationPersonnelAlgorithmsDefinitionModalBasicForm,
        ConfigurationAutomationPersonnelAlgorithmsDefinitionModalStepsForm
    }
})
export default class ConfigurationAutomationPersonnelAlgorithmsDefinitionModal extends Vue {
    @Ref() readonly algorithmsDefinitionModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): ConfigurationAutomaticAssignmentAlgorithmCreateRequest {
        return {
            name: this.state.automaticAssignmentAlgorithm.name!
        }
    }

    @Emit()
    update(): ConfigurationAutomaticAssignmentAlgorithmPatchInBatchRequest {
        return {
            id: this.state.automaticAssignmentAlgorithm.id!,
            name: this.state.automaticAssignmentAlgorithm.name
        }
    }

    state: ConfigurationAutomationPersonnelAlgorithmsDefinitionModalState

    get updateMode(): boolean {
        return !!this.state.automaticAssignmentAlgorithm?.id
    }

    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelAlgorithmsDefinitionModalState()
    }

    async show(automaticAssignmentAlgorithm?: ConfigurationAutomaticAssignmentAlgorithmResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAutomationPersonnelAlgorithmsDefinitionModalState()
        if (automaticAssignmentAlgorithm) {
            this.state.automaticAssignmentAlgorithm = automaticAssignmentAlgorithm
        }

        this.algorithmsDefinitionModal.show()
    }

    hide(): void {
        this.algorithmsDefinitionModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.automaticAssignmentAlgorithm) {
                if (this.updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }

            this.hide()
        }
    }
}
